<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div>
            <ProfileInformationSection
                :readonly="true"
                :user="localCompanyUserAggregate.user"
                :companyUser="localCompanyUserAggregate.companyUser"
            />
            <SideFormSectionDivider />
            <CompanyUserSettingsSection
                @onSuccess="handleUpdateCompanyUser($event)"
                :companyUser="localCompanyUserAggregate.companyUser"
            />
            <SideFormSectionDivider />
            <GenericAvailabilitySection
                :entityWithAssociatedAvailability="localCompanyUserAggregate"
                :availabilities="localAvailabilities"
                :associateAvailabilityUrl="
                    urlFactory.makeCompanyUserAssociateAvailabilityUrl(
                        localCompanyUserAggregate.companyUser.id,
                    )
                "
            />
            <SideFormSectionDivider />
            <CompanyUserServicesSection
                :origin="EditServiceOriginEnum.CompanyUserPage"
                :companyUserAggregate="localCompanyUserAggregate"
                :services="localServices"
            />
        </div>

        <PageBottomPadding />
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import Service from '@/App/Service/Entity/Service'
    import Availability from '@/App/Availability/Entity/Availability'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import SideFormSectionDivider from '@/Shared/Component/SideFormSectionDivider.vue'
    import PageBottomPadding from '@/Shared/Layout/App/Sidebar/PageBottomPadding.vue'
    import CompanyUserSettingsSection from '@/App/CompanyUser/Component/CompanyUserSettingsSection.vue'
    import GenericAvailabilitySection from '@/App/Availability/Component/GenericAvailabilitySection.vue'
    import CompanyUserServicesSection from '@/App/CompanyUser/Component/CompanyUserServicesSection.vue'
    import ProfileInformationSection from '@/App/User/Component/MyProfile/ProfileInformationSection.vue'
    import { EditServiceOriginEnum } from '@/Shared/AutoGenerated/Main'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    interface EditCompanyUserProps {
        pageMeta: PageMeta
        appSharedDataData: any
        companyUserAggregateData: any
        servicesData: any
        availabilitiesData: any
    }

    const props = defineProps<EditCompanyUserProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const localCompanyUserAggregate = ref<CompanyUserAggregate>(
        CompanyUserAggregate.hydrateSingle(props.companyUserAggregateData),
    )
    const localServices = ref<Service[]>(
        Service.hydrateMultiple(props.servicesData),
    )
    const localAvailabilities = ref<Availability[]>(
        Availability.hydrateMultiple(props.availabilitiesData),
    )
    const urlFactory = new UrlFactory()

    const handleUpdateCompanyUser = (event: {
        companyUserAggregate: CompanyUserAggregate
    }) => {
        localCompanyUserAggregate.value = event.companyUserAggregate
    }
</script>
